/*
 * reducers configuration
 */

import { combineReducers } from 'redux';

// import reducers
import fasTag from '../components/Fastag/Listing/reducer';
import fasTagDetail from '../components/Fastag/Detail/reducer';
import toaster from '../components/Toaster/reducer';
import loader from '../components/Loader/reducer';
import payment from '../components/Payment/reducer';
import passbook from '../components/Fastag/Passbook/reducer';
import workflow from '../pages/workflow/store/reducer';
import marketPlace from '../pages/web-views/marketplace/store/reducer';
import onboardingOperator from '../pages/web-views/onboarding-operator/store/reducer';
import subscribe from '../pages/web-views/subscribe/store/reducer';
import referral from '../pages/web-views/referral/store/reducer';
import autoComplete from '../components/UI/Organisms/AutoComplete/store/reducers';
import updateConsignment from '../pages/update-consignment/store/reducer';
import snackBar from '../components/UI/HOC/SnackBar/store/reducers';
import ums from '../pages/ums/store/reducer';
import consigner from '../pages/consigner/store/consigner.reducer';
import consignerPayment from '../pages/public/payments/store/reducer';
import consignerPlan from '../pages/public/plan/store/reducer';
import fleetLoadConfirmation from '../pages/public/fleet-load-confirmation/store/reducer';
import operatorTdsDeclaration from '../pages/public/operator-tds-declaration/store/reducer';
import operatorUndertaking from '../pages/public/operator-undertaking/store/reducer';

export default combineReducers({
  fasTag,
  fasTagDetail,
  toaster,
  payment,
  loader,
  passbook,
  workflow,
  marketPlace,
  subscribe,
  referral,
  autoComplete,
  updateConsignment,
  snackBar,
  ums,
  consigner,
  consignerPayment,
  consignerPlan,
  fleetLoadConfirmation,
  onboardingOperator,
  operatorTdsDeclaration,
  operatorUndertaking,
});
